import { Select, Banner } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import CustomerContactMultiSelect from "features/customer-contact-select/CustomerContactMultiSelect";
import UserSelectByPermissions from "features/user-select-by-permission/user-select-by-permission";
import UserSelect from "features/user-select/user-select";
import SignontabSelect from "features/signontab-select/SignontabSelect";

interface SignerPanelProps {
  customerId: string;
  selectedUser: string;
  onUserChange: (v: string) => void;
  selectedContactIds: string[];
  onContactChange: (v: string[]) => void;
  signType: string;
  onSignTypeChange: (v: string) => void;
  selectedNonTechUser: any;
  onNonTechUserChange: (v: any) => void;
  selectedTabUser: string;
  onTabUserChange: (v: string) => void;
  signCollection: { label: string; value: string }[];
  errors: { [key: string]: string };
}

export default function SignerPanel({
  customerId,
  selectedUser,
  onUserChange,
  selectedContactIds,
  onContactChange,
  signType,
  onSignTypeChange,
  selectedNonTechUser,
  onNonTechUserChange,
  selectedTabUser,
  onTabUserChange,
  signCollection,
  errors,
}: SignerPanelProps) {
  const { t } = useTranslation();

  // Click-to-sign cannot sign with external contacts (backend drops Contacts
  // rows) — hide the picker, but keep whatever is selected in state so it
  // reappears if the user switches back; buildPayload sends [] for Click.
  const isClickSignType = signType === "Click";

  return (
    <>
      <div style={{ marginBottom: "10px" }}>
        {!isClickSignType && (
          <CustomerContactMultiSelect
            label={"select_contact"}
            onChange={onContactChange}
            value={selectedContactIds}
            customerId={customerId}
            isRequired={true}
            error={errors["contactSigners"]}
          />
        )}

        <UserSelectByPermissions
          value={selectedUser}
          onChange={onUserChange}
          isRequired={true}
          Permission={"Signature"}
          error={errors["selectedUser"]}
        />

        <UserSelect
          onChange={onNonTechUserChange}
          value={selectedNonTechUser}
          label={"select_contact_user"}
        />
        <Select
          label={t("sign_type")}
          options={signCollection}
          value={signType}
          onChange={onSignTypeChange}
          requiredIndicator={true}
          error={errors["signType"]}
        />

        {signType === "Signontab" && (
          <SignontabSelect
            value={selectedTabUser}
            onChange={onTabUserChange}
          />
        )}
      </div>
      {selectedUser == selectedNonTechUser && (
        <div className="">
          <Banner tone="critical">
            {t("duplicate_signer_selected_choose_a_different_user")}
          </Banner>
        </div>
      )}
    </>
  );
}
